import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PayCodeRequestDto } from 'src/api/FiretrolApiClient';
import { payCodeApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreatePayCode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: PayCodeRequestDto) =>
      payCodeApiClient.create(request),
    meta: { suppressErrorToast: true },
    onSettled: () => invalidateFor('payCode.save', qc),
  });
}

export function useUpdatePayCode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, request }: { id: string; request: PayCodeRequestDto }) =>
      payCodeApiClient.update(id, request),
    meta: { suppressErrorToast: true },
    onSettled: () => invalidateFor('payCode.save', qc),
  });
}

export function useDeletePayCode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => payCodeApiClient.delete(id),
    meta: { suppressErrorToast: true },
    onSettled: () => invalidateFor('payCode.save', qc),
  });
}
